export enum DriveState {
  UNKNOWN = -1,
  IDLE = 0,
  READY = 1,
  RUNNING = 2,
}
